import { reatomAsync, withDataAtom } from "@reatom/async";
import { PageableRequestWithUserIdDto } from "definitions/poizon-bff";
import { API } from "src/api";
import { withIsLoadingAtom } from "src/common/pipes";

export const getOrders = reatomAsync(
  async (ctx, data: PageableRequestWithUserIdDto) => {
    return API.orderApi
      .orderControllerGetOrdersByUserId(data)
      .then((response) => response.data);
  },
  "getOrdersRequest",
).pipe(withDataAtom({ data: [], totalItems: 0 }), withIsLoadingAtom());
